
<div class="container">


    <h2 class="content-heading">
       
          Language Styles
    </h2>


  <div class="block">

    <!--
    <div class="block-header block-header-default">
        <h3 class="block-title"></h3>
    </div>
  -->

    <div class="block-content">
        <div class="table-responsive ">
            <table class="table table-striped table-vcenter table-sm">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th class="text-center" style="width: 100px;">Actions</th>
                    </tr>
                </thead>
                <tbody>


                  <tr *ngFor="let obj of entities">
                    <td class="font-w600">{{obj.Localized[0].Name}}</td>
                    {{obj.ReligionBranch.Name}}
                    <td class="text-center">
                        <div class="btn-group">
                           
                        </div>
                    </td>
                  </tr>

                </tbody>
            </table>

            <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

          </div>


    </div>

  </div>

  </div>

